<!-- 图片或视频下载tab页内容主页 -->
<template>
    <div v-cloak class="right-body" id="imageSaverVideo">
        <div class="imagesaver_content">
            <div class="url_content" :class="isShowInit?'url_content_init':''">
                <el-input ref="videlInputEle" class="url_input" type="input" :placeholder="inputFocus?'':$t('language.imageSaver.videoInputTip')"
                    v-model="urls" @input="limitRowsUrls" @paste.native="pastedUrl" @focus="inputFocus=true" @blur="inputFocus=false"></el-input>
                <el-button class="url_button" type="primary" :disabled="urls == ''" @click="clickDeCodeBtn" :loading="encodeing">{{encodeing ? $t('language.imageSaver.analyzing') : $t('language.imageSaver.download')}}</el-button>
            </div>
            <imageSaverPath v-show="node&&!isShowInit" :node="node" :updateTaskDestDrive="updateTaskDestDrive" :loadDestNode="loadDestNode"></imageSaverPath>
            <!-- 查询列表视图 -->
            <div class="imagesaver_video_view" v-if="!isShowInit">
                <!-- 查询结果标题及封面 -->
                <div class="imagesaver_video_header" v-if="title&&title.fullTitle">
                    <div class="imagesaver_video_header_cover">
                        <!-- 查询结果封面 -->
                        <el-image :src="title.thumbnailUrl" :fit="'contain'">
                            <div slot="error" class="image-slot">
                                <i class="picture-outline"></i>
                            </div>
                        </el-image>
                    </div>
                    <div class="imagesaver_video_header_title">
                        <!-- 查询结果标题 -->
                        <div class="imagesaver_video_header_txt" :title="title.fullTitle" >{{title.fullTitle}}</div>
                        <div class="imagesaver_video_header_items">
                            <!-- 发布者 -->
                            <div class="imagesaver_video_header_item" v-if="title.publisher">
                                <img v-if="title.avatar" :src="title.avatar">
                                <img v-else :src="require('../../assets/images/vectorImg/icon_User.svg')">
                                <span>{{title.publisher}}</span>
                            </div>
                            <!-- 发布时间 -->
                            <div class="imagesaver_video_header_item">
                                <img src="../../assets/images/vectorImg/date.svg" style="padding:5px;width:20px;height:20px;">
                                <span>{{title.date}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 查询结果 -->
                <div class="imagesaver_video_list table-list-1" v-if="datas&&datas.length>0">
                    <el-table id="imagesaverVideoView" :data="datas" stripe tooltip-effect="dark" style="width: 100%;" max-height="100%" height="100%">
                        <el-table-column label="Format" width="335">
                            <template slot-scope="scope">
                                <div class="table-cell">
                                    <div class="file-type" :class="matchfileType(scope.row.category)"></div>
                                    <div v-if="scope.row.category!='thumbnail'">{{toUpperCase(scope.row.ext)}}</div>
                                    <div v-else>{{$t('language.imageSaver.thumbnail')}}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="Quality" width="420">
                            <template slot-scope="scope">
                                <div class="table-cell" v-if="scope.row.category=='Video'">
                                    <span v-if="scope.row.quality">{{getQualityTxt(scope.row.quality)}}</span>
                                    <span v-if="scope.row.quality&&scope.row.fps">{{" · "}}</span>
                                    <span v-if="scope.row.fps">{{scope.row.fps + " FPS"}}</span>
                                    <span v-if="!scope.row.quality&&!scope.row.fps">{{" -- "}}</span>
                                    <div v-if="scope.row.formatId==title.bestVideoId" class="best-flag-video"></div>
                                </div>
                                <div class="table-cell" v-if="scope.row.category=='Audio'">
                                    <span v-if="scope.row.abr">{{$t('language.imageSaver.'+getAbtTxt(scope.row.abr))}}</span>
                                    <span v-else>--</span>
                                    <div v-if="scope.row.formatId==title.bestAudioId" class="best-flag-audio"></div>
                                </div>
                                <div class="table-cell" v-if="scope.row.category=='thumbnail'">
                                    <span v-if="scope.row.resolution">{{scope.row.resolution}}</span>
                                    <span v-else>{{$t('language.imageSaver.default')}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="Size">
                            <template slot-scope="scope">
                                <div class="table-cell">{{scope.row.fileSize|formatByte}}</div>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="">
                            <template slot-scope="scope">
                                <div class="table-cell">
                                    <div class="video-synthesizing" v-if="scope.row.synthesizing">
                                        <i></i>
                                        <span>{{$t('language.imageSaver.process')}}</span>
                                    </div>
                                    <div class="list-btns" v-else>
                                        <div class="list-btn" @click="saveToCloud(scope.row)">
                                            <div class="save-to-cloud"></div>
                                            {{$t('language.imageSaver.saveToCloud')}}
                                        </div>
                                        <div class="list-btn" @click="download(scope.row)">
                                            <div class="download"></div>
                                            {{$t('language.imageSaver.download')}}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="imagesaver_video_error" v-else>
                    <img src="../../assets/images/imageSaver/imageNo.svg" />
                    <div class="imagesaver_video_error_text">{{ $t('language.imageSaver.noImage') }}</div>
                    <div class="imagesaver_video_error_dest">{{ $t('language.imageSaver.notSupport') }}</div>
                </div>
            </div>
            <!-- 默认显示界面 -->
            <div class="imagesaver_video_default" v-else>
                <div class="imagesaver_video_default_tips" v-html="$t('language.imageSaver.videoTip')"></div>
                <div class="imagesaver_video_default_sites">
                    <div class="imagesaver_video_default_site" v-for="(site,index) in sites" :key="index" @click="jumpToSite(site.url)">
                        <img :src="require('../../assets/images/sitesLogo/'+site.name+'.png')">
                        {{site.name}}
                    </div>
                </div>
            </div>
        </div>
        <div class="img-buttom"></div>
        <!-- 保存目的地弹窗 -->
        <transferAimsDialog ref="transferAimsDialog"></transferAimsDialog>
    </div>
</template>

<script>
import Vue from 'vue';
import imageSaverPath from "@/components/workspace/image_saver_path";
import imageSaverTask from "@/components/workspace/image_saver_task";
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
import requestUtils from '@/js/request_util.js';
import '@/assets/css/table.css';
import '@/assets/css/imagesaver_common.css';

import transferAimsDialog from "@/components/popup/cloud_transfer_popups/task_single_popup";

export default {
    name: "imageSaverMain",
    components: {
        imageSaverPath,
        imageSaverTask,
        transferAimsDialog,
    },
    props: [],
    data() {
        return {
            pageName:'imageSaver',// 选择目的地文件夹弹窗确定时，判断需要用到
            urls: "",
            urlsLast: "",
            isShowInit: true,//是否显示初始化页面
            node:"",//saveToCloud位置
            inputHeight: 0,
            inputFocus: false,
            inputText: this.$t('language.imageSaver.inputTipHttp'),
            encodeing: false,
            title: {},
            datas: [],
            videoTypes: ['Video'],//视频类型列表
            audioTypes: ['Audio'],//音频类型列表
            sites: [{name:'YouTube',url:'https://www.youtube.com/'},
                {name:'Facebook',url:'https://www.facebook.com/'},
                {name:'X',url:'https://x.com/'},
                // {name:'TikTok',url:'https://www.tiktok.com/'},
                {name:'Twitch',url:'https://www.twitch.tv/'},
                {name:'Rumble',url:'https://www.rumble.com/'},
                {name:'SoundCloud',url:'https://soundcloud.com/'},
                {name:'Vimeo',url:'https://www.vimeo.com/'},
                {name:'Dailymotion',url:'https://www.dailymotion.com/'},
                {name:'Niconico',url:'https://blog.nicovideo.jp/niconews/'},
                {name:'Bilibili',url:'https://www.bilibili.com/'},
                // {name:'Likee',url:'https://likee.video/m_index'},
                ],//显示支持地址列表
            downloadTimer: null,//下载合成视频定时器
            tempSaveToCloudItem: null,//没有node时，临时保存item，选择地址后自动执行saveToCloud
        }
    },
    mounted() {
        // 获取任务目的地云盘
        this.loadDestNode();
    },
    computed: {
    },
    methods: {
        //点击解析按钮
        clickDeCodeBtn() {
            if(this.urls&&!this.isUrl(this.urls)) {
                this.isShowInit = false;
                this.title = {},this.data = {};//重置参数
                this.$toast({
                    text: this.$t('language.exception.invalidLink'),
                    type: 'fail',
                    idValue: "imageSaverVideo"
                });
                return;
            }else {
                this.decode();
            }
        },
        //解析视频
        decode() {
            if(this.urls){
                this.encodeing = true;
                requestUtils.doVideoSaverRequest("analyze_url",{ud:commonUtils.getUser().id,url:this.urls}).then(res => {
                    this.encodeing = false;
                    this.isShowInit = false;
                    if(res.code == 200 && res.message=="success"){
                        var data = res.data;

                        //时间，小于一分钟时显示0：秒
                        var duration = data.duration;
                        if(duration<60) {
                            duration = "0:" + duration;
                        }

                        this.title = {
                            fullTitle: data.fullTitle,
                            publisher: data.channel?data.channel:data.uploader,
                            thumbnailUrl: data.thumbnailUrl,
                            date: duration,
                            url: data.url,
                            bestAudioId: data.bestAudioId
                        }
                        if(data.avatar) {
                            this.title.avatar = data.avatar;
                        }
                        //处理数据集
                        this.sortAndConvertData(data.formatList);
                    }else if(res.code == 400 && res.reason) {
                        this.title = {},this.data = {};//重置参数
                        this.$toast({
                            text: this.$t('language.exception.' + res.reason),
                            type: 'fail',
                            idValue: "imageSaverVideo"
                        });
                    }else {
                        this.title = {},this.data = {};//重置参数
                        this.$toast({
                            text: this.$t('language.remoteTask.failedToParse'),
                            type: 'fail',
                            idValue: "imageSaverVideo"
                        });
                    }
                });
            }
        },
        //排序并转换数据
        sortAndConvertData(data) {
            let videoList = [];
            let audioList = [];
            let otherList = [];
            data.forEach(item => {
                if(item.category=="Video") {
                    if(item.resolution) {
                        //处理视频分辨率
                        let resolutionList = item.resolution.match(/\d+(\.\d+)?/g);
                        if(resolutionList&&resolutionList.length>1){
                            let resolution0 = parseInt(resolutionList[0]);
                            let resolution1 = parseInt(resolutionList[1]);
                            //处理分辨率
                            item.quality = resolution0 > resolution1? resolution1 : resolution0;
                        }
                    }else {
                        item.quality = -1;
                    }
                    videoList = this.addSortList(videoList,item);
                }else if(item.category=="Audio") {
                    audioList = this.addSortList(audioList,item);
                }else {
                    otherList = this.addSortList(otherList,item);
                }
                //是否启动合成视频标识
                item.synthesizing = false;
            });
            if(videoList.length>0) {
                //最佳视频分辨率
                this.title.bestVideoId = videoList[0].formatId;
            }

            //合并结果
            this.datas = [...videoList, ...audioList, ...otherList];
        },
        //获取分辨率文本
        getQualityTxt(num) {
            let quality;
            if(num > 1080) {
                quality = Math.floor(num / 500) + "K";
            }else if(num > 0) {
                quality = num + "P";
            }else {
                quality = "--";
            }
            return quality;
        },
        //获取清晰度文本
        getAbtTxt(abr) {
            if(abr && abr>0) {
                return abr>96?abr>192?abr>320?'abrTypeVeryHigh':'abrTypeHigh':'abrTypeNormal':'abrTypeLow';
            }else {
                return "--";
            }
        },
        //字符串转大写
        toUpperCase(str) {
            if(str){
                return str.toString().toUpperCase();
            }else {
                return str;
            }
        },
        //添加数据到已排序集合
        addSortList(list,item) {
            list.push(item);
            if(item.category=="Video") {
                //视频类型排序
                list.sort(
                    function (a, b) {
                        return b.quality - a.quality;
                    }
                );
            }else if(item.category=="Audio") {
                //音频类型排序
                list.sort(
                    function (a, b) {
                        return b.abr - a.abr;
                    }
                );
            }
            return list;
        },
        saveToCloud(item) {
            if (!this.node) {
                this.tempSaveToCloudItem = item;
                this.$refs.transferAimsDialog.taskSingleShow = true;
                return;
            }else if(this.tempSaveToCloudItem){
                //清空临时参数，防止重复执行
                this.tempSaveToCloudItem = null;
            }
            let data = {
                ud: commonUtils.getUser().id,
                //云盘信息
                cloudToId: this.node.id,
                path: this.node.folder,
                nodes: this.toBase64(this.node.path),
                //主题信息
                fullTitle: this.title.fullTitle,
                //文件信息
                category: item.category,
            };
            if(this.title.url) {
                data.url = this.title.url;
            }
            if(this.title.thumbnailUrl) {
                data.thumbnailUrl = this.title.thumbnailUrl;
            }
            if(item.fileSize != undefined) {
                data.fileSize = item.fileSize;
            }
            if(this.title.bestAudioId) {
                data.bestAudioId = this.title.bestAudioId;
            }
            if(this.title.date) {
                data.duration = this.title.date;
            }
            if(item.formatId) {
                //formatId
                data.formatId = item.formatId;
            }
            if(item.resolution) {
                //分辨率
                data.resolution = item.resolution;
            }
            if(item.abr) {
                //fps
                data.abr = item.abr;
            }
            if(item.vbr) {
                //fps
                data.vbr = item.vbr;
            }
            if(item.ext) {
                //fps
                data.ext = item.ext;
            }
            this.$multcloudGA('video_upload_'+item.category);
            requestUtils.doVideoSaverRequest("save_task",data).then(res => {
                if(res.code == 200 && res.message=="success"){
                    this.$store.state.videlSaverTaskListAddNewNumber += 1;
                }else {
                    this.$toast({
                        text: this.$t('language.exception.requestFailed'),
                        type: 'fail',
                        idValue: "imageSaverVideo"
                    });
                }
            });
        },
        download(item) {
            this.$multcloudGA('video_down_'+item.category)
            if(item.isOriginalLink) {
                //源链接下载
                window.open(item.url);
            }else if(item.category=="thumbnail") {
                //缩略图下载
                requestUtils.doVideoSaverRequest("image_download_add",{ud:commonUtils.getUser().id,thumbnailUrl:item.url}).then(res => {
                    if(res.code == 200 && res.message=="success"){
                        if(res.data.link){
                            let e = commonUtils.createDownloadFormVideosaver(res.data.link);
                            e.submit();
                        }
                    }else {
                        this.$toast({
                            text: this.$t('language.exception.requestFailed'),
                            type: 'fail',
                            idValue: "imageSaverVideo"
                        });
                    }
                });
            }else {
                //非源链接下载
                let data = {
                    ud: commonUtils.getUser().id,
                    fullTitle: this.title.fullTitle,
                    isOriginalLink: item.isOriginalLink,
                    category: item.category,
                }
                if(this.title.url) {
                    data.url = this.title.url;
                }
                if(this.title.bestAudioId) {
                    data.bestAudioId = this.title.bestAudioId;
                }
                if(item.formatId) {
                    //formatId
                    data.formatId = item.formatId;
                }
                if(item.ext) {
                    //fps
                    data.ext = item.ext;
                }
                item.synthesizing = true;
                requestUtils.doVideoSaverRequest("download_add",data).then(res => {
                    if(res.code == 200 && res.message=="success"){
                        if(res.data.downloadTaskId){
                            this.getDownloadProgress(item,res.data.downloadTaskId);
                            return;
                        }
                    }else {
                        this.$toast({
                            text: this.$t('language.exception.requestFailed'),
                            type: 'fail',
                            idValue: "imageSaverVideo"
                        });
                    }
                    item.synthesizing = false;//关闭合成中状态
                });
            }
        },
        //定时获取视频下载合成进度状态
        getDownloadProgress(item,id) {
            this.downloadTimer = setTimeout(() => {
                requestUtils.doVideoSaverRequest("download_progress",{ud:commonUtils.getUser().id,downloadTaskId:id}).then(res => {
                    if(res.code == 200 && res.message=="success"){
                        if(res.data.status!="Pending") {
                            clearTimeout(this.downloadTimer);
                            item.synthesizing = false;//关闭合成中状态
                            if(res.data.status=="Done"){
                                //已完成
                                //下载文件
                                let e = commonUtils.createDownloadFormVideosaver(res.data.link);
                                e.submit();
                            }else if(res.data.msg=="exceeds2GB"){
                                this.$toast({
                                    text: this.$t('language.exception.exceeds2GB'),
                                    type: 'fail',
                                    idValue: "imageSaverVideo"
                                });
                            }else if(res.data.status=="Fail"){
                                this.$toast({
                                    text: this.$t('language.exception.requestFailed'),
                                    type: 'fail',
                                    idValue: "imageSaverVideo"
                                });
                            }
                            return;
                        }
                    }else {
                        this.$toast({
                            text: this.$t('language.exception.requestFailed'),
                            type: 'fail',
                            idValue: "imageSaverVideo"
                        });
                        item.synthesizing = false;//关闭合成中状态
                        clearTimeout(this.downloadTimer);
                        return;
                    }
                    this.getDownloadProgress(item,id);
                });
            }, 3000);
        },
        //音视频图标判断
        matchfileType(type) {
            if(this.videoTypes.includes(type)) {
                return "video";
            }else if(this.audioTypes.includes(type)) {
                return "audio";
            }else {
                return type;
            }
        },
        //空文本状态粘贴后执行
        pastedUrl(event) {
            var items = (event.clipboardData || event.originalEvent.clipboardData).items;
            for (var index in items) {
                var item = items[index];
                if (item.kind === 'string' && item.type === 'text/plain') {
                    item.getAsString(string => {
                        // 在这里执行粘贴后的操作
                        this.urls = string;
                        if(this.urls&&!this.isUrl(this.urls)) {
                            this.isShowInit = false;
                            this.$toast({
                                text: this.$t('language.exception.invalidLink'),
                                type: 'fail',
                                idValue: "imageSaverVideo"
                            });
                            return;
                        }else {
                            //是链接才执行
                            this.decode();
                        }
                    });
                }
            }
        },
        //判断是否是链接
        isUrl(str) {
            const pattern = new RegExp('https?:\/\/[^\/$.?#].[^\s]*');
            return pattern.test(str);
        },
        // 只能输入1行网址
        limitRowsUrls() {
            if (this.urls.split('\n').length > 1) {
                this.urls = this.urlsLast;
            } else {
                this.urlsLast = this.urls;
            }
            setTimeout(() => {
                this.inputHeight = this.$refs.videlInputEle.$el.offsetHeight;
            }, 0);
        },
        // 字符串Base64编码
        toBase64(str) {
            // 创建一个 TextEncoder 实例
            const encoder = new TextEncoder();
            // 将字符串转换为一个 Uint8Array
            const byteArray = encoder.encode(str);
            // 转Base64
            let binary = '';
            const len = byteArray.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(byteArray[i]);
            }
            return btoa(binary);
        },
        // 更新任务目的地云盘
        updateTaskDestDrive(node) {
            // 准备节点信息
            var tempNode = {};
            // 获取文件夹ID
            if (node.pnode) {
                tempNode.folder = node.id;
            } else {
                tempNode.folder = node.rootId;
            }
            // 获取云盘信息
            var path = [];
            var temp = node;
            while (temp.pnode) {
                path.push({id:temp.id,name:temp.name});
                temp = temp.pnode;
            }
            path.push({id:temp.rootId,name:temp.name});
            tempNode.path = JSON.stringify(path);
            tempNode.id = temp.id;
            tempNode.type = temp.driveType;
            // 更新节点参数准备
            var data = {};
            data.id = tempNode.id;
            data.dt = tempNode.type;
            data.n = this.toBase64(tempNode.path);
            data.pt = tempNode.folder;
            this.node = tempNode;
            // 更新节点请求
            taskListUtils.imageSaverRequest("/updateTaskDestDrive", data, res => {
                if (res.code == 200) {
                    // 更新成功
                    this.node = tempNode;
                    if(this.tempSaveToCloudItem) {
                        this.saveToCloud(this.tempSaveToCloudItem);
                    }
                } else {
                    // 更新失败
                    this.node = null;
                    this.errorTips(res.message);
                    if(this.tempSaveToCloudItem) {
                        this.tempSaveToCloudItem = null;//清空临时参数，防止重复执行
                    }
                }
            });
        },
        // 加载目的地节点
        loadDestNode() {
            taskListUtils.imageSaverRequest("/loadTaskDestDrive", {}, res => {
                if (res.code == 200) {
                    this.node = res.data;
                } else {
                    this.node = null;
                }
            });
        },
        // 设置选择的Node
        setNode(node) {
            this.updateTaskDestDrive(node);
        },
        //打开网址
        jumpToSite(url) {
            window.open(url, '_blank');
        },
    },
}
</script>

<style scoped>
#imageSaverVideo {
    position: relative;
}

.imagesaver_content {
    display: flex;
    flex-direction: column;
    height: -webkit-fill-available;
    padding: 20px 50px;
    /*no*/
}

.imagesaver_video_view {
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #D3DCF0;
    /*no*/
    padding: 40px;
    /*no*/
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    z-index: 2;
}

.imagesaver_video_list {
    flex-grow: 1;
    box-sizing: border-box;
    border: 1px solid #D3DCF0;
    /*no*/
    height: 0;
}

.imagesaver_video_error {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-family: Arial;
    line-height: normal;
    letter-spacing: 0em;
}

.imagesaver_video_error_text {
    font-size: 24px;
    /*no*/
    font-weight: bold;
    color: #333333;
    margin: 40px 0 10px;
    /*no*/
}

.imagesaver_video_error_dest {
    font-size: 16px;
    /*no*/
    font-weight: normal;
    color: #6F6F6F;
}

.imagesaver_video_header {
    display: flex;
    padding-bottom: 40px;
    /*no*/
    overflow: hidden;
}

.imagesaver_video_header_cover {
    flex-shrink: 0;
    margin-left: 20px;
    width: 320px;
     /*no*/
    height: 180px;
     /*no*/
}

.imagesaver_video_header_cover .el-image {
    width:100%;
    height:100%;
    border-radius: 8px;/*no*/
}

.imagesaver_video_header_cover .el-image >>> .el-image__inner {
    background: rgba(0, 0, 0, 0.08);
}

.imagesaver_video_header_cover .picture-outline {
    width: 320px;/*no*/
    height: 180px;/*no*/
    border-radius: 8px;/*no*/
    background: url("../../assets/images/imageSaver/coverError.svg") center no-repeat,rgba(0, 0, 0, 0.03);
    display: flex;
    justify-content: center;
    align-items: center;
}

.imagesaver_video_header_title {
    margin-left: 40px;
    /*no*/
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;
    padding: 10px 0;
    /*no*/
    color: #6F6F6F;
}

.imagesaver_video_header_txt {
    color: #333333;
    font-size: 20px;
    /*no*/
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.imagesaver_video_header_items {
    display: flex;
    align-items: center;
    margin-top: 30px;
    /*no*/
}

.imagesaver_video_header_item {
    display: flex;
    align-items: center;
    margin-right: 40px;
    /*no*/
    max-width: 300px;
    /*no*/
    font-family: Microsoft YaHei UI;
    font-size: 16px;
    /*no*/
    font-weight: normal;
    line-height: 50px;
    /*no*/
    letter-spacing: 0em;
}

.imagesaver_video_header_item img{
    width: 40px;
    /*no*/
    height: 40px;
    /*no*/
    margin-right: 10px;
    /*no*/
}

.imagesaver_video_default {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
}

.imagesaver_video_default_tips {
    width: 900px;/*no*/
    font-family: Microsoft YaHei UI;
    font-size: 18px;/*no*/
    font-weight: normal;
    line-height: 140%;/*no*/
    letter-spacing: 0em;
    color: #333333;
    margin-top: 16px;/*no*/
    margin-bottom: 40px;/*no*/
    text-align: center;
}

.imagesaver_video_default_sites {
    display: flex;
    flex-wrap: wrap;
    width: 600px;/*no*/
}

.imagesaver_video_default_site {
    width: 120px;/*no*/
    height: 100px;/*no*/
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 20px 0;/*no*/
    font-family: Microsoft YaHei UI;
    font-size: 14px;/*no*/
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    cursor: pointer;
}

.imagesaver_video_default_site:hover {
    color: #5562B4;
}

.imagesaver_video_default_site img{
    width: 40px;/*no*/
    padding: 16px;/*no*/
    background: #fff;
    border-radius: 40px;/*no*/
    margin-bottom: 10px;/*no*/
}

.imagesaver_video_default_site:hover img{
    border: 1px solid rgba(211, 220, 240, 0.5);/*no*/
    box-shadow: 0px 4px 8px -2px rgba(62, 70, 120, 0.3);/*no*/
}

.table-cell {
    display: flex;
    align-items: center;
    gap: 10px;
    /*no*/
}

.list-btns {
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
}

.list-btn {
    cursor: pointer;
    margin-right: 30px;
    /*no*/
    text-align: center;
    padding: 0px 10px 0px 10px;
    /*no*/
    gap: 5px;
    background: rgba(80, 101, 187, 0.05);
    /*no*/
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    /*no*/
    font-weight: normal;
    letter-spacing: 0em;
    color: #5562B4;
}

.video-synthesizing {
    position: absolute;
    line-height: 20px;
    /*no*/
    text-align: right;
    color: #6F6F6F;
}

.video-synthesizing i {
    animation: rotating 2s linear infinite;
    line-height: 1;
    vertical-align: baseline;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    vertical-align: middle;
}

.video-synthesizing i:before{
    content: url('../../assets/images/imageSaver/loading2.png');
}

#imageSaverVideo >>> .table-list-1 .el-table__header .el-table__cell:nth-last-child(2):before {
    display: none;
}

/* 滚动条 */
#imagesaverVideoView >>> .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px; /*no*/
    height: 6px; /*no*/
    background-color: transparent;
}

/* 滚动条 */
#imagesaverVideoView >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
    width: 4px; /*no*/
    height: 4px; /*no*/
    border-radius: 4px; /*no*/
    background: #BECAE4;
    min-height: 100px; /*no*/
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/video_saver.vue